'use client';
import Typography from '@/components/shared/typography/typography.component';
import {
    ImperfectionStatusEnum,
    ModalTagProps,
} from '@/types/imperfection-report.types';

import styles from './styles.module.scss';
import { ReactNode } from 'react';
import colors from '@/theme/colors.module.scss';
import { IVariant } from '@/components/shared/typography/typography.types';

interface ComponentProps {
    children?: ReactNode;
}

interface CustomWithStyle extends ComponentProps {
    style: any;
}
interface CustomTypographyProps extends ComponentProps {
    variant?: IVariant;
}

const ModalTabsText = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className={styles.ModalTabsText} variant={variant}>
            <>{children}</>
        </Typography>
    );
};

const ModalSectionTitle = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className={styles.ModalSectionTitle} variant={variant}>
            <>{children}</>
        </Typography>
    );
};
const ModalPropertySectionContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.ModalPropertySectionContainer}>
            <>{children}</>
        </div>
    );
};

const ModalPropertyItemContainer = ({
    children,
    style = {},
}: CustomWithStyle) => {
    return (
        <div className={styles.ModalPropertyItemContainer} style={style}>
            <>{children}</>
        </div>
    );
};

const ModalPropertyItem = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className={styles.ModalPropertyItem} variant={variant}>
            <>{children}</>
        </Typography>
    );
};

const ModalPropertyWarningText = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography
            className={styles.ModalPropertyWarningText}
            variant={variant}
        >
            <>{children}</>
        </Typography>
    );
};

const ModalPropertyValueText = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography className={styles.ModalPropertyValueText} variant={variant}>
            <>{children}</>
        </Typography>
    );
};

interface ModalTagPropsWithChildren extends ModalTagProps, ComponentProps {
    variant: IVariant;
}

const ModalTagValue = ({
    children,
    status,
    variant,
}: ModalTagPropsWithChildren) => {
    return (
        <Typography
            className={styles.ModalPropertyValueText}
            variant={variant}
            style={{
                background:
                    status !== ImperfectionStatusEnum.Faulty
                        ? colors.primary50
                        : colors.warning50,
                color:
                    status !== ImperfectionStatusEnum.Faulty
                        ? colors.primary700
                        : colors.warning700,
                textAlign: 'center',
                padding: '2px 8px',
                whiteSpace: 'nowrap',
                borderRadius: '16px',
            }}
        >
            <>{children}</>
        </Typography>
    );
};

const ModalTagContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.ModalTagContainer}>
            <>{children}</>
        </div>
    );
};

export {
    ModalTabsText,
    ModalSectionTitle,
    ModalPropertyItemContainer,
    ModalPropertySectionContainer,
    ModalPropertyItem,
    ModalPropertyWarningText,
    ModalPropertyValueText,
    ModalTagValue,
    ModalTagContainer,
};
